// addClass :: String -> Element -> Effect Unit
export const addClass = (className) => (element) => () =>
  className.length > 0 ? element.classList.add(className) : undefined;

// removeClass :: String -> Element -> Effect Unit
export const removeClass = (className) => (element) => () =>
  className.length > 0 ? element.classList.remove(className) : undefined;

// hasClass :: String -> Element -> Effect Boolean
export const hasClass = (className) => (element) => () =>
  element.classList.contains(className);

// setInnerHtml :: String -> Element -> Effect Unit
export const setInnerHtml = (html) => (element) => () =>
  (element.innerHTML = html);

// setInnerText :: String -> Element -> Effect Unit
export const setInnerText = (text) => (element) => () =>
  (element.innerText = text);

// focus :: Element -> Effect Unit
export const focus = (element) => () => element.focus();

// Warning, element.dataset[] translates keys from kebab to camel case, example:
// el = <tag data-example-attribute></tag>; el.dataset["exampleAttribute"]

const kebabToCamelCase = (str) =>
  str.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

const containsOnlyNumbers = (str) => /^\d+$/.test(str);

const parseDataset = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    if (containsOnlyNumbers(data)) {
      return parseFloat(data);
    } else {
      return data;
    }
  }
};

// getData :: String -> Element -> Effect Foreign
export const getData = (attr) => (element) => () =>
  element.restaumaticData?.get(attr) ??
  parseDataset(element.dataset[kebabToCamelCase(attr)]);

// setData :: String -> Foreign -> Element -> Effect Unit
export const setData = (attr) => (value) => (element) => () => {
  if (element.restaumaticData === undefined) {
    element.restaumaticData = new Map();
  }

  element.restaumaticData.set(attr, value);
};

// getValue :: Element -> Effect Foreign
export const getValue = (element) => () => element.value;

// parents :: String -> Element -> Effect (Array Element)
export const parents = (selector) => (element) => () => {
  let parent = element.parentElement;

  const matchedParents = [];

  while (parent !== null) {
    if (parent.matches(selector)) {
      matchedParents.push(parent);
    }

    parent = parent.parentElement;
  }

  return matchedParents;
};

export const closestImpl =
  (just) => (nothing) => (selector) => (element) => () => {
    let parent = element;

    while (parent !== null) {
      if (parent.matches(selector)) {
        return just(parent);
      }

      parent = parent.parentElement;
    }

    return nothing;
  };

// queueMicrotask :: Effect Unit -> Effect Unit
export const queueMicrotask = (microtask) => () =>
  window.queueMicrotask(microtask);

// addTestLoadedMarker :: String -> Effect Unit
export const addTestLoadedMarker = (markerName) => () => {
  var div = document.createElement("div");
  div.setAttribute("data-testid", markerName);
  div.style.position = "absolute";
  div.style.top = "0";
  div.style.left = "0";
  div.style.width = "1px";
  div.style.height = "1px";

  document.body.appendChild(div);
};

// logErrorOnElement :: String -> Element -> Effect Unit
export const logErrorOnElement = (msg) => (element) => () =>
  console.error(msg, element);
